import api from './api';

const fournitureService = {
  // Routes publiques
  getAll: (params = {}) => {
    return api.get('/fournitures', { params });
  },

  getById: (id) => {
    return api.get(`/fournitures/${id}`);
  },

  incrementTelechargement: (id) => {
    return api.post(`/fournitures/${id}/telecharger`);
  },

  getPublicSchedules: (params = {}) => {
    return api.get('/emplois-du-temps/public', { params });
  },

  getScheduleByClasse: (classe, anneeScolaire = '2026-2027') => {
    return api.get(`/emplois-du-temps/classe/${classe}/${anneeScolaire}`);
  },

  // Routes admin
  admin: {
    getAll: (params = {}) => {
      return api.get('/admin/fournitures', { params });
    },

    create: (data) => {
      return api.post('/admin/fournitures', data);
    },

    update: (id, data) => {
      return api.put(`/admin/fournitures/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/fournitures/${id}`);
    }
  }
};

export default fournitureService;
